// extracted by mini-css-extract-plugin
module.exports = {"app":"wrapper_app__1RQsj","dataFetchWarning":"wrapper_dataFetchWarning__15Dlp"};